import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M300.045-697.691q-20.814 0-35.429 14.57-14.615 14.57-14.615 35.384 0 20.815 14.57 35.43 14.57 14.615 35.384 14.615t35.429-14.57q14.615-14.57 14.615-35.384t-14.57-35.43q-14.57-14.615-35.384-14.615zm0 375.383q-20.814 0-35.429 14.57-14.615 14.57-14.615 35.384t14.57 35.43q14.57 14.615 35.384 14.615t35.429-14.57q14.615-14.57 14.615-35.384 0-20.815-14.57-35.43-14.57-14.615-35.384-14.615zM175.386-807.69h609.228q15.039 0 25.212 10.145 10.173 10.146 10.173 25.143v247.017q0 16.231-10.173 26.961-10.173 10.731-25.212 10.731H175.386q-15.039 0-25.212-10.731-10.173-10.73-10.173-26.961v-247.017q0-14.997 10.173-25.143 10.173-10.145 25.212-10.145zM200-747.691v200h560v-200H200zm-24.614 315.384h608.459q15.846 0 26 10.615 10.154 10.616 10.154 26.308v244.613q0 17-10.154 27.73-10.154 10.731-26 10.731h-607.69q-15.846 0-26-10.731-10.154-10.73-10.154-27.73v-244.613q0-15.692 9.77-26.308 9.769-10.615 25.615-10.615zM200-372.309v200h560v-200H200zm0-375.382v200-200zm0 375.382v200-200z"
      ></path>
    </svg>
  );
}

export default Icon;
